import React from "react";

export default function ModalDialogWrapper(Component, Id) {
    console.log("ModalDialogWrapper(Component, Id)")

    return () => (
        <div className = { 'outer ' + Id }>
            <div className="inner">
                <Component />
            </div>
        </div>
    );
}
